/** Browsers on older ICU builds report the legacy id; Go and the picker use the modern one, so one campaign never holds both. */
const LEGACY_ZONES: Record<string, string> = { 'Asia/Calcutta': 'Asia/Kolkata' };

/** The admin's IANA zone as the browser reports it (owner 2026-10-13: the browser-detected zone for now).
 *  Undefined when the browser reports none, so a request omits admin_tz and Go uses the campaign zone. */
export function browserTimeZone(): string | undefined {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return zone ? (LEGACY_ZONES[zone] ?? zone) : undefined;
  } catch {
    return undefined;
  }
}
